import React,{Component} from 'react';
import { firebaseAuth,ref , base } from '../config/constants'
import ReactTable from 'react-table'
import "react-table/react-table.css";


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Bended from './Bended';
import Footer from './inc/Footer';

class BendedPriceList extends Component{

	constructor(){
    super();
    this.redirect = this.redirect.bind(this)
    this.removeProduct = this.removeProduct.bind(this);
    this.state = {
            userId : "",
            user : {},
            list : {}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });
        
        var list = ref.child('BendedPrice').orderByChild('status').equalTo('Active');
            list.on("value", function(data){
            
                this.setState({
                list : data.val()
                })
            
            }.bind(this))       
    } 

    redirect(id){
        window.location.assign("/dimension/"+id+"/edit")
    }

    removeProduct(id){
        let list = this.state.list;
        let product = {}
        if(window.confirm("Do you really want to remove this product")===true){
            Object.keys(list).map(key =>{
                product = list[id] 
                if(product === list[key]){
                    let statusUpdate ={
                        status : "Inactive"
                    }
                    ref.child("BendedPrice").child(id).update(statusUpdate).then(()=>{
                        alert("Dimension successfully deleted ")
                    })// end of update in the firebase
                } // end of condition  
            } ) //end of loop
        }// end of window confirm
    }


    componentWillUnmount(){
        this.listener()
    } 

    render() {
       var x = [];
        this.state.list &&
        Object.keys(this.state.list).map(key => {
            let list = this.state.list[key]
                list.id = key
                list.dimension = list.dimension.toUpperCase();
            x.push(list)
            }) 
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Bended Accessories Dimension and Price" />
                            
                            <div className="block">
                              <div className="block full">
                                <div className="block-title">
                                  <h2><strong>All</strong> Products</h2>
                                </div>
                                    <ReactTable
                                        data={x}
                                        columns={[
                                            {
                                                Header: "Dimension",
                                                accessor : "dimension",
                                                filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                            },
                                            {
                                                Header: "0.4MM",
                                                accessor : "price_4MM"
                                            },
                                            {
                                                Header: "0.5MM",
                                                accessor : "price_5MM"
                                            },
                                            {
                                                Header: "0.6MM",
                                                accessor : "price_6MM"
                                            },
                                            {
                                                Header: "0.8MM",
                                                accessor : "price_8MM"
                                            },
                                            {
                                                Header: 'Action',
                                                accessor : "id",
                                                Cell : row => (
                                                    <span><button onClick={()=>this.redirect(row.value)}><i className="fa fa-pencil"></i></button>
                                                    <button onClick={()=>this.removeProduct(row.value)}><i className="fa fa-times"></i></button></span>
                                                )
                                                                                   
                                            }
                                        ]}
                                        
                                        filterable ={true}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                    />   
                                
                              </div>    
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default  BendedPriceList;



// WEBPACK FOOTER //
// ./src/components/BendedPriceList.js